import { render, staticRenderFns } from "./cardUser.vue?vue&type=template&id=1bd66e63&scoped=true"
import script from "./cardUser.vue?vue&type=script&lang=js"
export * from "./cardUser.vue?vue&type=script&lang=js"
import style0 from "./cardUser.vue?vue&type=style&index=0&id=1bd66e63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd66e63",
  null
  
)

export default component.exports